// =============================================================================
// components/ScreenUnavailable.tsx — NEUTRAL "couldn't load" fallback.
//
// Used when a lazily-required screen module fails to evaluate (e.g. the LiveKit
// voice/video screens whose native module can't init in a given environment).
// Deliberately NOT the crypto "Coming Soon — CRYB v2" screen: live rooms and
// calling are shipping SOCIAL features, not v2 crypto surfaces, so a load failure
// must read as a transient "couldn't start here", never as "coming in v2".
// =============================================================================
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Asset3D from './ui/Asset3D';
import { colors, spacing, radius, typographyScale } from '../constants/theme';

export function makeUnavailable(title: string, message: string) {
  return function ScreenUnavailable() {
    const navigation = useNavigation<any>();
    return (
      <View style={styles.wrap}>
        <Asset3D name="error" size={104} style={{ marginBottom: spacing.md }} />
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.msg}>{message}</Text>
        <TouchableOpacity
          style={styles.btn}
          onPress={() => { if (navigation.canGoBack()) navigation.goBack(); }}
          accessibilityRole="button"
          accessibilityLabel="Go back"
        >
          <Text style={styles.btnText}>Go back</Text>
        </TouchableOpacity>
      </View>
    );
  };
}

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.xxl,
    backgroundColor: colors.bg,
  },
  title: {
    ...(typographyScale.h3 as object),
    color: colors.ink,
    textAlign: 'center',
    marginBottom: spacing.xs,
  },
  msg: {
    ...(typographyScale.body as object),
    color: colors.muted,
    textAlign: 'center',
    marginBottom: spacing.xl,
  },
  btn: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.xxl,
    borderRadius: radius.full,
  },
  btnText: { color: '#FFFFFF', fontWeight: '700', fontSize: 15 },
});

export default makeUnavailable;
